const sizes = {
    sm: {
        fontSize: 'xs',
    },
    md: {
        fontSize: 'sm',
    },
};
export default {
    // Styles for the base style
    baseStyle: {},
    // Styles for the size variations
    sizes,
    // Styles for the visual style variations
    variants: {},
    // The default `size` or `variant` values
    defaultProps: {
        size: 'md',
    },
};
//# sourceMappingURL=caption.js.map